export default __webpack_public_path__ + "static/media/whatsapp.7771f2fb.svg";